module.exports = __webpack_public_path__ + "media/images/qr-code-4291f847fbb31c16840f815285622e61.png";